import { render, staticRenderFns } from "./RoutesOrder.vue?vue&type=template&id=5d123fd1&"
import script from "./RoutesOrder.vue?vue&type=script&lang=js&"
export * from "./RoutesOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports